<template>
  <div class="d-flex justify-content-end">
    <Tooltip title="Produtos">
      <Button _key="btnItems" type="default" classIcon="fa-sharp-duotone fa-solid fa-list" size="small"
              :params="moviment" :clicked="onItems"/>
    </Tooltip>
    <Tooltip title="Compartilhar">
      <Button _key="btnPrint" type="info" classIcon="fa-light fa-share-nodes" size="small"
              :params="moviment" :clicked="onPrint"/>
    </Tooltip>
    <Tooltip title="Anexo">
      <Button _key="btnAttachment" type="primary" classIcon="fa-solid fa-paperclip" size="small"
              :params="moviment" :clicked="onAttachment"/>
    </Tooltip>
    <Tooltip title="Excluir">
      <Button v-if="isUserTemp" _key="btnDeleteMoviment" type="danger" classIcon="fa-solid fa-trash" size="small"
              :params="moviment" :clicked="onDelete"/>
    </Tooltip>
  </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Tooltip from "@nixweb/nixloc-ui/src/component/layout/Tooltip";
import {mapMutations, mapState} from "vuex";

export default {
  name: "MovimentButtons",
  components: {Button, Tooltip},
  props: {
    moviment: {type: Object, required: true},
  },
  computed: {
    ...mapState("user", ["userLogged"]),
    isUserTemp() {
      return this.userLogged && this.userLogged.user && this.userLogged.user.userName === "UserTemp";
    },
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
    onPrint(params) {
      this.$emit("print", params);
      this.removeLoading(["btnPrint"]);
    },
    onAttachment(params) {
      this.$emit("attachment", params);
      this.removeLoading(["btnAttachment"]);
    },
    onItems(params) {
      this.$emit("open-items", params);
      this.removeLoading(["btnItems"]);
    },
    onDelete(params) {
      this.$emit("delete", params);
      this.removeLoading(["btnDeleteMoviment"]);
    },
  },
};
</script>
